import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);

interface CustomerStoryCarouselProps {
    el: HTMLElement;
}

const CustomerStoryCarousel = ({ el }: CustomerStoryCarouselProps): void => {
    const swiperContainer = el.querySelector('.customer-story-carousel-scroll') as HTMLDivElement;
    const items = el.querySelectorAll('.customer-story-card ');

    if (!swiperContainer || items.length < 1) {
        return;
    }

    items.forEach(item => {
        item.classList.add('swiper-slide');
    });


    const nextBtn = el.querySelector('.customer-story-carousel-button.next') as HTMLButtonElement;
    const prevBtn = el.querySelector('.customer-story-carousel-button.prev') as HTMLButtonElement;
    const pagination = el.querySelector('.swiper-pagination') as HTMLDivElement;


    const isDivOverflowing = (divElement: HTMLElement): boolean => {
        const rect = divElement.getBoundingClientRect();
        return (
            rect.right > window.innerWidth || rect.left < 0
        );
    };


    const updateOpacity = (): void => {
        items.forEach(item => {
            if (isDivOverflowing(item as HTMLDivElement)) {
                item.classList.add('offscreen');
            } else {
                item.classList.remove('offscreen');
            }
        });
    };

    const cardSwiper = new Swiper(swiperContainer, {
        init: false,
        modules: [A11y],
        slidesPerView: 'auto' as number | 'auto',
        threshold: 10,
        touchReleaseOnEdges: true,
        pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        on: {
            slideChangeTransitionEnd: (): void => {
                updateOpacity();
            },
            reachEnd: (): void => {
                // add set timeout to compensate for the animation length
                setTimeout(() => {
                    updateOpacity();
                }, 100);
            },
        },
    });

    cardSwiper.init();

    // Update the opacity on window resize
    addEventListener('resize', () => {
        updateOpacity();
    });

    // Check if the slider is in view
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Update the opacity and disconnect the observer.
                // We'll only need to update this once.
                // the rest can be done on slider interaction.
                updateOpacity();
                observer.disconnect();
            }
        });
    });
    observer.observe(swiperContainer);
};

export default CustomerStoryCarousel;
